module.exports = __webpack_public_path__ + "public/images/slider/nedbay-circle.dd0e040cc7b982e1d81acc549d44045c.webp";